import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { toast } from 'react-toastify';
import FormHelper from '../form.js';
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js';
import ModalSelectInMap from '../../../../utils/Modal/ModalSelectInMap.js';
import Module from '../../../../utils/Render.js';
import SelectQuery from '../../../../component/SelectQuery.js';
import Request from '../../../../config/Request.js'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
 import 'react-phone-number-input/rrui.css' 



export default class ModalContractor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alias          : "",
      name           : "",
      address1       : "",
      address2       : "",
      postal         : "",
      city           : {pk: "", Name: ""},
      phone          : "",
      email          : "",
      contact_person : "",
      is_process     : false,
      modalMap       : false,
    }
    
    this.modalAction = this.modalAction.bind(this)
    this.toggleModalSelectInMap = this.toggleModalSelectInMap.bind(this);

    this.onRegister        = this.onRegister.bind(this)
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this)
    this.onRegisterFailed  = this.onRegisterFailed.bind(this)

    this.onUpdate          = this.onUpdate.bind(this)
    this.onUpdateSuccess   = this.onUpdateSuccess.bind(this)
    this.onUpdateFailed    = this.onUpdateFailed.bind(this)
  }

  // Get Data from google map
  toggleModalSelectInMap(){
    this.setState({ modalMap : !this.state.modalMap })
  }

  getMapLocation(data){
    this.setState({
      address1  : data.address,
      address2  : data.address2,
      postal    : data.postal,
      // city      : Module.GetCityValue(this.props.cityMaster, data.city)
    })
  }

  modalAction() {
    const {mode} = this.props

    if(!FormHelper.ValidateForm(this.state)) {
      return
    }
    
    let data = { 
      alias          : this.state.alias,
      name           : this.state.name,
      address1       : this.state.address1,
      address2       : this.state.address2,
      postal         : this.state.postal,
      city           : this.state.city,
      phone          : this.state.phone,
      email          : this.state.email,
      contact_person : this.state.contact_person,
    }

    if(mode === "modal_add") {
      this.onRegister(data);

    } else {
      this.onUpdate(data)
    }
  }

    // ==================== Register
  onRegister(data) {

    let payload = {
      Name                : data.name,
      Address1            : data.address1,
      Address2            : data.address2,
      City                : data.city,
      PostalCode          : data.postal,
      PhoneNumber         : data.phone,
      Email               : data.email,
      ContactPersonName   : data.contact_person,
    }

    Request(
      "post",
      "register-contractor",
      {Authorization: "Bearer " + this.props.UserReducer.token},
      payload,
      [],
      this.onRegisterSuccess,
      this.onRegisterFailed,
    )

    this.setState({is_process: true}) 
  }

  onRegisterSuccess(response) {
    toast.success("Register contractor success")
    this.setState({ is_process: false })
    this.props.close()
    this.props.onSuccess()
  }

  onRegisterFailed(error) {
    this.setState({ is_process: false })
    this.props.onFailed(error)
  }

  // ==================== Register
  onUpdate(data) {
    this.setState({is_process: true}) 

    let payload = {
     Name                : data.name,
     Address1            : data.address1,
     Address2            : data.address2,
     City                : data.city,
     PostalCode          : data.postal,
     PhoneNumber         : data.phone,
     Email               : data.email,
     ContactPersonName   : data.contact_person,
    }

    Request(
      "put",
      "update-contractor",
      {Authorization: "Bearer " + this.props.UserReducer.token},
      payload,
      [data.alias],
      this.onUpdateSuccess,
      this.onUpdateFailed,
    )
  }

  onUpdateSuccess(response) {
    toast.success("Update contractor success")
    this.setState({ is_process: false })
    this.props.close()
    this.props.onSuccess()
  }

  onUpdateFailed(error) {
    this.setState({ is_process: false })
    this.props.onFailed(error)
  }

  componentWillReceiveProps(nextProps) {
    let new_state = {}
    if(nextProps.mode === 'modal_update') {

      new_state = {
        alias          : nextProps.data.alias,
        name           : nextProps.data.name,
        address1       : nextProps.data.address1,
        address2       : nextProps.data.address2,
        postal         : nextProps.data.postal,
        city           : nextProps.data.city.pk,
        phone          : nextProps.data.phone,
        email          : nextProps.data.email,
        contact_person : nextProps.data.contact_person,
      }
    } else {
      new_state = {
        alias          : "",
        name           : "",
        address1       : "",
        address2       : "",
        postal         : "",
        city           : "",
        phone          : "",
        email          : "",
        contact_person : "",
      }
    }
    this.setState(new_state)
  }

  exitModal() {
    this.setState({
      alias          : "",
      name           : "",
      address1       : "",
      address2       : "",
      postal         : "",
      city           : "",
      phone          : "",
      email          : "",
      contact_person : "",
      is_process: false,
    })
  }

  render() {
    const {isModal, close, mode} = this.props
    return (
      <Modal isOpen={isModal} toggle={close} className="modal-lg" onExit={()=>this.exitModal()}>
        <ModalHeader toggle={close}>{mode === "modal_add" ? 'Add new' : 'Update'} Contractor</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-6">
              <label className="required">Name</label>
              <input 
                type="text"
                className="form-control"
                placeholder="Type Name"
                value={this.state.name || ""}
                onChange={(e) => this.setState({name: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Contact Person</label>
              <input 
                type="text"
                className="form-control"
                placeholder="Type Contact Person"
                value={this.state.contact_person || ""}
                onChange={(e) => this.setState({contact_person: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-6">
              {Module.SelectInMapButton(this.toggleModalSelectInMap)}
              <label className="required">Address 1</label>
              <input 
                type="text"
                className="form-control"
                placeholder="Type Address Contractor"
                value={this.state.address1 || ""}
                onChange={(e) => this.setState({address1: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Address 2</label>
              <input 
                type="text"
                className="form-control"
                placeholder="Type Address Contractor"
                value={this.state.address2 || ""}
                onChange={(e) => this.setState({address2: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Postal</label>
              <input 
                type="text"
                className="form-control"
                placeholder="Type Postal Code"
                value={this.state.postal || ""}
                onChange={(e) => this.setState({postal: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">City</label>
              <SelectQuery 
                placeholder="Type City"
                value={this.state.city}
                onChange={(e) => this.setState({city: e.value})}
                urlKey="read-city-all-autocomplete"
                valKey="pk"
                valLabel="Name"
                initOption={this.props.data.city}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Phone number</label>
              <PhoneInput 
                className="form-control"
                placeholder="Enter phone number"
                value={ this.state.phone }
                onChange={ phone => this.setState({ phone }) }
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Email</label>
              <input 
                type="email"
                className="form-control"
                placeholder="Type Email"
                value={this.state.email || ""}
                onChange={(e) => this.setState({email: e.target.value})}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={close}>cancel</ButtonCancel>
          <ButtonValidation is_process={this.state.is_process} onClick={this.modalAction}>
            {mode === "modal_add" ? "Save" : "Update"}
          </ButtonValidation>
        </ModalFooter>

        <ModalSelectInMap 
          defaultLocation = {{
            'latitude'  : -43.525650, 
            'longitude' : 172.639847
          }}
          onSave          = {this.getMapLocation.bind(this)}
          isOpen          = {this.state.modalMap}
          closeModal      = {this.toggleModalSelectInMap}
        />
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/master/contractor/helper/component/Modal.js